import React from 'react';
import { motion } from 'framer-motion';
import { NoirBackground } from '../components/GameUI';
import { ArrowLeft } from 'lucide-react';

const TermsOfService = ({ onBack }) => (
  <div className="min-h-dvh flex flex-col items-center p-6 relative select-none">
    <NoirBackground />
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
      className="w-full max-w-md space-y-6 relative z-10 py-8">
      <button onClick={onBack} data-testid="terms-back-btn"
        className="flex items-center gap-2 font-mono text-[#5A5A5A] text-xs uppercase tracking-wider hover:text-[#EF4444] transition-colors">
        <ArrowLeft size={14} /> Back
      </button>
      <div>
        <h1 className="font-typewriter text-4xl text-[#E0DDD5]">Terms of Service</h1>
        <div className="red-line w-full mt-3" />
      </div>
      <div className="space-y-5 text-sm text-[#888] font-mono leading-relaxed">
        <p>Last updated: February 2026</p>
        <div>
          <h2 className="text-[#E0DDD5] font-bold uppercase tracking-wider text-xs mb-2">Acceptance</h2>
          <p>By using IMPOSTER, you agree to these terms. If you do not agree, please do not use the app.</p>
        </div>
        <div>
          <h2 className="text-[#E0DDD5] font-bold uppercase tracking-wider text-xs mb-2">Use of the Game</h2>
          <p>IMPOSTER is a free-to-play social deduction party game intended for entertainment purposes. You may use it for personal, non-commercial use. The game is provided "as is" without warranties of any kind.</p>
        </div>
        <div>
          <h2 className="text-[#E0DDD5] font-bold uppercase tracking-wider text-xs mb-2">Intellectual Property</h2>
          <p>All content, design, and code of IMPOSTER are the property of the creator. You may not copy, modify, distribute, or reverse-engineer any part of this application without written permission.</p>
        </div>
        <div>
          <h2 className="text-[#E0DDD5] font-bold uppercase tracking-wider text-xs mb-2">Advertisements</h2>
          <p>The game may display third-party advertisements. We are not responsible for the content of these ads or any interactions you have with advertisers.</p>
        </div>
        <div>
          <h2 className="text-[#E0DDD5] font-bold uppercase tracking-wider text-xs mb-2">Limitation of Liability</h2>
          <p>We shall not be liable for any damages arising from the use or inability to use this game. Use it at your own risk and enjoy responsibly.</p>
        </div>
        <div>
          <h2 className="text-[#E0DDD5] font-bold uppercase tracking-wider text-xs mb-2">Changes</h2>
          <p>We reserve the right to modify these terms at any time. Continued use of the game constitutes acceptance of updated terms.</p>
        </div>
      </div>
    </motion.div>
  </div>
);

export default TermsOfService;
